import { render, staticRenderFns } from "./reactivate-procedure.vue?vue&type=template&id=558033a3&"
import script from "./reactivate-procedure.vue?vue&type=script&lang=js&"
export * from "./reactivate-procedure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports